


































































































































































































































import { defineComponent, reactive } from "@vue/composition-api";
import { Button, InputContainer, Toggle } from "@micad/vue-components";
import { Client, getClientTypeOptions } from "@/assets/js/constants";
import router from "@/router";
import { createClient, getClients } from "@/data/repos/client";
import { displayRequestStatus } from "@/notifications";
import { QIcon } from "quasar";
import "@micad/vue-components/src/styles/components/SearchableSelect.scss";
export default defineComponent({
  name: "ClientCreate",
  components: {
    InputContainer,
    Button,
    Toggle,
    QIcon,
  },
  props: { parentKey: String },
  setup(p) {
    const parentKey = router.currentRoute.params.parentKey;
    const state = reactive({
      client: { active: true, type: "" } as Client,
      serverErrorMessage: "",
      busy: false,
      parentClient: {} as Client,
      parentClientList: [] as Client[],
      clientTypeOptions: getClientTypeOptions(),
      submit,
      resetForm,
      goBack: () => router.back(),
      resetParentClient: () => (state.parentClient = {} as Client),
    });

    async function resetForm() {
      state.client = { active: true } as Client;
    }

    getClients({ includeChildren: true, hideInactive: true }).then((data) => {
      state.parentClientList = data.payload || [];
      if (p.parentKey)
        state.parentClientList.forEach(
          (c) =>
            (state.parentClient =
              p.parentKey === c.key ? c : state.parentClient)
        );
      state.busy = false;
    });

    async function submit() {
      state.busy = true;
      state.client.parentId = state.parentClient!.id;
      state.client.type = state.client.type ? state.client.type : undefined;
      const resp = await createClient(state.client);
      state.serverErrorMessage = resp.ok ? "" : resp.status?.errorMessage || "";
      displayRequestStatus(
        resp,
        "Client has been created",
        "Failed to create client. Internal server error."
      );
      if (resp.ok) {
        await router.push({
          name: "Clients",
        });
      }
      state.busy = false;
    }

    return state;
  },
});
